"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IMAGE_FILL_CENTER = exports.IMAGE_FILL_STRETCH = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var useStyles = (0, _styles.makeStyles)({
  btnRoot: {
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  container: {
    position: 'relative',
    width: 'inherit',
    height: 'inherit',
    textAlign: 'center',
    overflow: 'hidden',
    padding: 0,
    borderRadius: 0
  },
  imageStretch: {
    height: 'inherit',
    width: 'inherit',
    maxWidth: '100%'
  },
  imageCenter: {
    maxWidth: '100%'
  },
  text: {
    position: 'absolute',
    bottom: '0px',
    width: 'inherit',
    height: 'auto',
    background: 'rgba(0, 0, 0, 0.5)',
    color: '#fff',
    boxSizing: 'border-box',
    padding: '10px',
    overflowWrap: 'break-word',
    textAlign: 'left',
    textTransform: 'initial'
  }
}, {
  name: 'Mui-WidgetImage'
});
var IMAGE_FILL_STRETCH = 'stretch';
exports.IMAGE_FILL_STRETCH = IMAGE_FILL_STRETCH;
var IMAGE_FILL_CENTER = 'center';
exports.IMAGE_FILL_CENTER = IMAGE_FILL_CENTER;

var Image = (_ref) => {
  var {
    src,
    text,
    alt,
    crossOrigin,
    fill = IMAGE_FILL_STRETCH,
    onClick,
    url
  } = _ref;
  var classes = useStyles();
  var [loaded, setLoaded] = (0, _react.useState)(false);
  var IMAGE_FILL_CLASSES = {
    [IMAGE_FILL_CENTER]: classes.imageCenter,
    [IMAGE_FILL_STRETCH]: classes.imageStretch
  };
  var isButton = !!url;

  var handleClick = event => {
    event.preventDefault();
    return onClick && onClick(event);
  };
  /* eslint-disable react/jsx-props-no-spreading */


  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
    variant: "rect",
    width: "inherit",
    height: "inherit",
    style: {
      display: loaded ? 'none' : 'inherit'
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    component: "a",
    style: {
      display: loaded ? 'flex' : 'none'
    },
    className: classes.container,
    classes: !isButton ? {
      root: classes.btnRoot
    } : {},
    disableRipple: !isButton,
    onClick: handleClick
  }, url && {
    href: url
  }), /*#__PURE__*/_react.default.createElement("img", {
    className: IMAGE_FILL_CLASSES[fill]
    /*
      This *must* be before src, due to an order-of-attributes bug
      https://github.com/facebook/react/issues/14035
       The conditional is necessary because an empty string is the same
      as setting "anonymous"; to not use CORS at all, we have to not
      set the attribute.
    */
    ,
    crossOrigin: crossOrigin || undefined,
    src: src,
    onLoad: () => setLoaded(true),
    alt: alt
  }), text && text.trim() && /*#__PURE__*/_react.default.createElement(_Typography.default, {
    "data-testid": "overlay-text-image",
    className: classes.text
  }, text)));
};

Image.propTypes = {
  /**
   * This is the src of image
   */
  src: _propTypes.default.string,

  /**
   * This is the overlay text
   */
  text: _propTypes.default.string,

  /**
   * Alt text for broken image
   */
  alt: _propTypes.default.string,
  crossOrigin: _propTypes.default.string,

  /**
   * Choose between stretch or center for placing the image
   */
  fill: _propTypes.default.oneOf([IMAGE_FILL_STRETCH, IMAGE_FILL_CENTER]),

  /**
   * This is a function implementation when clicking on the static image
   */
  onClick: _propTypes.default.func,

  /**
   * Passed as href to the button
   */
  url: _propTypes.default.string
};
var _default = Image;
exports.default = _default;